// extracted by mini-css-extract-plugin
export default {"KanbanItem":"KanbanItem_KanbanItem__6Rr2-"};